<template>
    <transition>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Reports </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Doctor Service Report</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-primary float-right" @click="toggleModal">
                              Add New
                            </button>  -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 ">
                    <div class="card">
                        <div class="card-header">
                            <h3 style="text-align: center;">Doctor Service Report</h3>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4"></div>
                                <div class="col-md-4" style="margin-bottom: 20px; text-align: center;">
                                    <div class="form-check-inline">
                                        <label class="form-check-label" for="daily" style="margin: 0px 0px 0px 0px; padding: 8px 0;">
                                            <input type="radio" class="form-check-input" id="daily" v-model="tableData.type" value="daily" checked @click="changeReportType()"> Daily
                                        </label>
                                    </div>
                                    <div class="form-check-inline">
                                        <label class="form-check-label" for="monthly" style="margin: 0px 0px 0px 0px; padding: 8px 0;">
                                            <input type="radio" class="form-check-input" id="monthly" v-model="tableData.type" value="monthly" @click="changeReportType()"> Monthly
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-4"></div>

                                <div class="col-md-3">
                                    <div class="">
                                        <label for="department_id"> Department </label> <br>
                                        <Multiselect
                                            class="form-control border department_id"
                                            mode="single"
                                            v-model="tableData.department_id"
                                            placeholder="Select Department"
                                            :searchable="true"
                                            :filter-results="true"
                                            :options="department_options"
                                            :classes="multiclasses"
                                            :close-on-select="true"
                                            :min-chars="1"
                                            :resolve-on-load="false"
                                            @change="changeDepartment"
                                        />
                                        <div class="invalid-feedback" v-if="errors.department_id">
                                            {{errors.department_id[0]}}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="">
                                        <label for="doctor_id"> Doctor </label> <br>
                                        <Multiselect
                                            class="form-control border doctor_id"
                                            mode="single"
                                            v-model="tableData.doctor_id"
                                            placeholder="Select Doctor"
                                            :searchable="true"
                                            :filter-results="true"
                                            :options="doctor_options"
                                            :classes="multiclasses"
                                            :close-on-select="true"
                                            :min-chars="1"
                                            :resolve-on-load="false"
                                        />
                                        <div class="invalid-feedback" v-if="errors.doctor_id">
                                            {{errors.doctor_id[0]}}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="">
                                        <label for="from_date"> From </label>
                                        <input type="date" class="form-control" id="from_date" v-model="tableData.from_date" @change="onkeyPress('from_date')">
                                        <div class="invalid-feedback" v-if="errors.from_date">
                                            {{errors.from_date[0]}}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="">
                                        <label for="to_date"> To </label>
                                        <input type="date" class="form-control" id="to_date" v-model="tableData.to_date" @change="onkeyPress('to_date')">
                                        <div class="invalid-feedback" v-if="errors.to_date">
                                            {{errors.to_date[0]}}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="mt-3">
                                        <button type="submit" class="btn-sm btn btn-primary" :disabled="disabled" @click="filterGetDailyDoctorServiceReport()">
                                            <span v-show="isSubmit">
                                                <i class="fas fa-spinner fa-spin" ></i>
                                            </span>Submit 
                                        </button>
                                        <a href="javascript:void(0);" style="margin-left: 5px;" class="btn-sm btn btn-primary" @click.prevent="printItem(item)" ><i class="mdi mdi-printer-outline me-1"></i>Print</a>
                                        <!-- <a href="javascript:void(0);" style="margin-left: 5px;" class="btn-sm btn btn-primary"
                                        @click.prevent="downloading ? null : exportToExcel()">
                                            <span v-show="downloading"  >
                                                <i class="fas fa-spinner fa-spin"></i>
                                            </span> 
                                            <i class="mdi mdi-file-excel me-1"></i> 
                                        </a> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body table-responsive">
                            <h4 style="text-align: center;">Doctor Service Report</h4>
                            <h4 style="text-align: center;" v-if="from_date != '' && to_date != ''">From {{ from_date }} To {{ to_date }}</h4>
                            
                            <div class="report_data" v-if="(!loading && tableData.type == 'monthly')">
                                <table id="basic-datatable" class="table table-bordered table-centered nowrap w-100"
                                    v-for="(month_item, i) in monthly_items" :key="i">
                                    <thead class="table-light">
                                        <!-- <tr class="border success item-head">
                                            <th width="15%"> </th>
                                            <th width="25%" colspan="4" style="text-align: center;">Details</th>
                                            <th width="10%" colspan="2" style="text-align: center;">Service</th>
                                        </tr> -->
                                        <tr class="border success item-head">
                                            <th width="15%">Month </th>
                                            <th width="25%">Name</th>
                                            <th width="20%">Department</th>
                                            <th width="10%" style="text-align: center;">No. of Patient</th>
                                            <th width="10%" style="text-align: center;">Receive</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="month_item.length > 0">
                                        <tr class="border" v-for="(item, j) in month_item" :key="j">
                                            <td>{{ item.month_year }}</td>
                                            <td>{{ item.first_name +' '+ item.last_name }}</td>
                                            <td>{{ item.department_name }}</td>
                                            <td style="text-align: center;">{{ item.no_of_service }}</td>
                                            <td style="text-align: right;">{{ parseFloat(item.receive_amount).toFixed(0) }}</td>
                                        </tr>

                                    </tbody>

                                    <tfoot>
                                        <tr>
                                            <th colspan="3" style="text-align: center"> Total</th>
                                            <th style="text-align: center">{{ totalCalculateAmount(month_item, 'no_of_service') }}</th>
                                            <th style="text-align: right">{{ totalCalculateAmount(month_item, 'receive_amount') }}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            <div class="report_data" v-else>
                                <table id="basic-datatable" class="table table-bordered table-centered nowrap w-100"
                                v-if="!loading && daily_items.length > 0">
                                    <thead class="table-light">
                                        <!-- <tr class="border success item-head">
                                            <th width="15%"> </th>
                                            <th width="25%" colspan="4" style="text-align: center;">Details</th>
                                            <th width="10%" colspan="2" style="text-align: center;">Service</th>
                                        </tr> -->
                                        <tr class="border success item-head">
                                            <th width="15%">Date</th>
                                            <th width="25%">Doctor Name</th>
                                            <th width="20%">Department</th>
                                            <th width="10%" style="text-align: center;">No. of Patient</th>
                                            <th width="10%" style="text-align: center;">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="border" v-for="(item, i) in daily_items" :key="i">
                                            <td>{{ item.appointment_date }}</td>
                                            <td>{{ item.first_name +' '+ item.last_name }}</td>
                                            <td>{{ item.department_name }}</td>
                                            <td style="text-align: center;">{{ item.no_of_service }}</td>
                                            <td style="text-align: right;">{{ parseFloat(item.receive_amount).toFixed(0) }}</td>
                                        </tr>
                                    </tbody>

                                    <tfoot>
                                        <tr>
                                            <th colspan="3" style="text-align: center"> Total</th>
                                            <th style="text-align: center">{{ totalCalculateAmount(daily_items, 'no_of_service') }}</th>
                                            <th style="text-align: right">{{ totalCalculateAmount(daily_items, 'receive_amount') }}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            

                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div>

                        </div> 
                    </div>

                    <Modal @close="toggleModal()"  >
                        <div class="modal-content scrollbar-width-thin orderPreview" >
                            <div class="modal-header"> 
                                <button @click="toggleModal()" type="button" class="btn btn-default">X</button>
                                <h3 style="width: 100%">Doctor Service Report</h3>
                            </div>
                            <div class="modal-body " id="printArea" >
                                <div class="table-responsive product_table">
                                    <table class="table po_invoice">
                                        <tr>
                                            <td colspan="2" class="text-center" style="position: relative;">
                                                <h5 class="text-uppercase">{{ this.retailShopName }}</h5>
                                                <h6 class="text-uppercase">{{ this.retailSmallText }}</h6>
                                                <p>{{ this.retailShopAddress }} </p>
                                                <h4 style="text-align: center;">Doctor Service Report</h4>
                                                <h5 style="text-align: center;" v-if="from_date != '' && to_date != ''">From {{ from_date }} TO {{ to_date }}</h5>
                                            </td>
                                        </tr>
                                    </table>
                                    <div class="report_data" v-if="(!loading && tableData.type == 'monthly')">
                                        <table id="basic-datatable" class="table table-bordered table-centered nowrap w-100"
                                            v-for="(month_item, i) in monthly_items" :key="i">
                                            <thead class="table-light">
                                                <!-- <tr class="border success item-head">
                                                    <th width="15%"> </th>
                                                    <th width="25%" colspan="4" style="text-align: center;">Details</th>
                                                    <th width="10%" colspan="2" style="text-align: center;">Service</th>
                                                </tr> -->
                                                <tr class="border success item-head">
                                                    <th width="15%">Month </th>
                                                    <th width="25%">Name</th>
                                                    <th width="20%">Department</th>
                                                    <th width="10%" style="text-align: center;">No. of Patient</th>
                                                    <th width="10%" style="text-align: center;">Receive</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="month_item.length > 0">
                                                <tr class="border" v-for="(item, j) in month_item" :key="j">
                                                    <td>{{ item.month_year }}</td>
                                                    <td>{{ item.first_name +' '+ item.last_name }}</td>
                                                    <td>{{ item.department_name }}</td>
                                                    <td style="text-align: center;">{{ item.no_of_service }}</td>
                                                    <td style="text-align: right;">{{  parseFloat(item.receive_amount).toFixed(0) }}</td>
                                                </tr>

                                            </tbody>

                                            <tfoot>
                                                <tr>
                                                    <th colspan="3" style="text-align: center"> Total</th>
                                                    <th style="text-align: center">{{ totalCalculateAmount(month_item, 'no_of_service') }}</th>
                                                    <th style="text-align: right">{{ totalCalculateAmount(month_item, 'receive_amount') }}</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                    <div class="report_data" v-else>
                                        <table id="basic-datatable" class="table table-bordered table-centered nowrap w-100"
                                        v-if="!loading && daily_items.length > 0">
                                            <thead class="table-light">
                                                <!-- <tr class="border success item-head">
                                                    <th width="15%"> </th>
                                                    <th width="25%" colspan="4" style="text-align: center;">Details</th>
                                                    <th width="10%" colspan="2" style="text-align: center;">Service</th>
                                                </tr> -->
                                                <tr class="border success item-head">
                                                    <th width="15%">Date </th>
                                                    <th width="25%">Name</th>
                                                    <th width="20%">Department</th>
                                                    <th width="10%" style="text-align: center;">No. of Patient</th>
                                                    <th width="10%" style="text-align: center;">Receive</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="border" v-for="(item, i) in daily_items" :key="i">
                                                    <td>{{ item.appointment_date }}</td>
                                                    <td>{{ item.first_name +' '+ item.last_name }}</td>
                                                    <td>{{ item.department_name }}</td>
                                                    <td style="text-align: center;">{{ item.no_of_service }}</td>
                                                    <td style="text-align: right;">{{ parseFloat(item.receive_amount).toFixed(0) }}</td>
                                                </tr>
                                            </tbody>

                                            <tfoot>
                                                <tr>
                                                    <th colspan="3" style="text-align: center"> Total</th>
                                                    <th style="text-align: center">{{ totalCalculateAmount(daily_items, 'no_of_service') }}</th>
                                                    <th style="text-align: right">{{ totalCalculateAmount(daily_items, 'receive_amount') }}</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>        
        </div>
    </transition>
</template>
<script>
import Modal from "./../../helper/Modal";
import { ref, onMounted } from "vue";
import axios from 'axios';
import Form from 'vform';
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';

export default {
    name: 'PosLeftbar',
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },  
    data() {
        return {
            loading: true,
            downloading: false,
            isSubmit: false,
            disabled: true,
            showModal: false,
            modalActive:false,
            errors: {},
            daily_items: [],
            monthly_items: [],
            departments: [],
            department_options: [],
            categories: [],
            category_options: [],
            doctors: [],
            doctor_options: [],
            multiclasses: { 
              clear: '',
              clearIcon: '', 
            }, 
            from_date: '',
            to_date: '',
            
            tableData: {
                column: 0,
                dir: 'desc',
                sortKey: 'appointment_date', 
                type: 'daily',
                department_id: '',
                doctor_id: '',
                from_date: '',
                to_date: '',
            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }
        };
    },
    created() {
        this.fetchDepartments();
        this.fetchDoctors();
        this.getDailyDoctorServiceReport();
    },

    methods: { 

        toggleModal: function() {
            this.modalActive = !this.modalActive;  
            this.errors = '';
            this.isSubmit = false;
        },

        fetchDepartments() { 
            axios.get(this.apiUrl+'/hm/departments', this.headerjson)
            .then((res) => {
                this.departments = res.data.data;
                res.data.data.map((item) => {
                    this.department_options.push({label:item.name, value:item.id});
                });
            }) 
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
        }, 

        fetchDoctors() {
            this.doctor_options = [];
            axios.get(this.apiUrl+"/hm/doctors", this.headerjson)
            .then((resp) => {
                this.doctors = resp.data.data;
                resp.data.data.map((item) => {
                    this.doctor_options.push({value: item.id, label: item.name});
                })
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
        },

        changeDepartment(value) {
            let department_id = value;
            this.tableData.doctor_id = '';
            let doctors = this.doctors.filter((item) => item.department_id == department_id);
            this.doctor_options = doctors.map((item) => {
                return {value: item.id, label: item.name};
            });
            
        },

        // Change Report Type
        changeReportType() {    
            this.loading = true;
            this.tableData.type = this.tableData.type == "daily" ? "monthly" : "daily";
            this.getDailyDoctorServiceReport();
        },

        filterGetDailyDoctorServiceReport()
        {
            this.isSubmit = true;
            this.disabled = true;
            this.getDailyDoctorServiceReport();
        },

        // For Pagination 
        getDailyDoctorServiceReport(url = this.apiUrl+'/reports/daily-doctor-service-report') {
            axios.get(url, {params:this.tableData, headers:this.headerparams})
            .then((response) => {
                let data = response.data.data; 
                if("monthly" == this.tableData.type) {
                    this.daily_items = [];
                    this.monthly_items = data.service_data;
                }else {
                    this.monthly_items = [];
                    this.daily_items = data.service_data;    
                }
                this.tableData.from_date = data.from_date;
                this.tableData.to_date = data.to_date;

            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
                this.isSubmit = false;
                this.disabled = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.getDailySalesReport();
        },
        setPage(data){  
            this.getDailySalesReport(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },
        // End Pagination

        checkRequiredPrimary()
        {
            if(this.tableData.from_date != '' && this.tableData.to_date != '') {
                this.disabled = false;
            }else{
                this.disabled = true;
            }
        },
        onkeyPress: function(field) { 
            this.checkRequiredPrimary();
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        printItem: function () {   
            this.printContent('printArea');
        },

        printContent(document_id) { 
            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    this.baseUrlPrintCSS+'/assets/css/print.css'
                ],
            };
            this.$htmlToPaper(document_id, options);
        },
        async exportToExcel() { 
            const queryString = this.objectToQueryString( this.tableData); 
            this.downloading = true; 

            const query = queryString;
            try {
                const response = await axios.get(`${this.apiUrl}/reports/daily-sales-report-excel-export${query}`, {
                responseType: 'blob', // Important: set the response type to 'blob'
                headers: {
                    'Authorization' : this.$store.getters.token ? `Bearer ${this.$store.getters.token}` : "",
                    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // Specify the expected content type
                }
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Daily-Sale-Report.xlsx');
                document.body.appendChild(link);
                link.click();
                this.downloading = false;
            } catch (error) { 
                this.downloading = false;
            }
        },
        
        objectToQueryString: function (obj) {   
            const queryString = Object.keys(obj)
                .filter((key) => obj[key] !== undefined) // Exclude undefined values
                .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
                .join('&');
            return `?${queryString}`;
        }, 
        totalCalculateAmount(items, field) {
            if(field == 'no_of_service') {
                return items.reduce(function(total, item) {
                    return total + parseFloat(item.no_of_service);
                }, 0);
            }else if(field == 'receive_amount') {
                return items.reduce(function(total, item) {
                    return total + parseFloat(item.receive_amount);
                }, 0);
            }else if(field == 'days') {
                return items.reduce(function(total, item) {
                    return total + parseFloat(25);
                }, 0);
            }else if(field == 'hours') {
                return items.reduce(function(total, item) {
                    return total + parseFloat(8);
                }, 0);
            }else {
                return 0;
            }
        },


    },

    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        
    }
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 90%;
    display: block;
    margin: 0 auto;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}

.actions a{
    margin-right: 5px;
}
</style>